import { useRouter } from 'next/router';
import { extractParametersFromUrl } from '@/helpers/pages/channel';
import useShowBySlug from '@/react-query/shows/hooks/useShowBySlug';

const useShow = (queryParams) => {
  const { query } = useRouter();
  const { slug: showSlug } = extractParametersFromUrl({ query });
  
  return useShowBySlug({
    ...queryParams,
    slug: showSlug
  });
};

export default useShow;